
import swr from "swr";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix, fetchWithDecoderWithoutErrorPage } from "../CommunicationV2.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { ofArray, singleton } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { AssignedTrackerDto_$reflection, AssignTrackerDto_$reflection, AssignedTrackersDto_$reflection, TrackHistoryDto_$reflection, TrackerMapConfigurationDto_$reflection, TrackerOverviewPageDto_$reflection } from "../Shared/Telematics.js";
import { NotImplementedResponse, ValidationOnGetRequest } from "../ErrorHandling.js";
import { Union } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { string_type, union_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { escapeDataString } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { toUniversalTime, toString } from "../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { Auto_generateBoxedEncoder_437914C6, toString as toString_1 } from "../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { concat } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";

export function useTrackersIf(enabled) {
    return swr(enabled ? "/api/telematics/trackers" : "", (url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoderWithoutErrorPage(addPrefix(url), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), TrackerOverviewPageDto_$reflection()));
    }).then((_arg) => {
        const result_1 = _arg;
        return (result_1.tag === 1) ? (Promise.resolve((() => {
            throw new ValidationOnGetRequest(result_1.fields[0]);
        })())) : (Promise.resolve(result_1.fields[0]));
    })))), {
        refreshInterval: 60000,
        revalidateOnFocus: true,
    });
}

export function useTrackers() {
    return useTrackersIf(true);
}

export function useMapConfiguration() {
    return swr("/api/telematics/map", (url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoderWithoutErrorPage(addPrefix(url), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), TrackerMapConfigurationDto_$reflection()));
    }).then((_arg) => {
        const result_1 = _arg;
        return (result_1.tag === 1) ? (Promise.resolve((() => {
            throw new ValidationOnGetRequest(result_1.fields[0]);
        })())) : (Promise.resolve(result_1.fields[0]));
    })))), {
        revalidateOnFocus: false,
    });
}

export class HistoryResult extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Loaded", "NotSupported"];
    }
}

export function HistoryResult_$reflection() {
    return union_type("Requests.Telematics.HistoryResult", [], HistoryResult, () => [[["Item", TrackHistoryDto_$reflection()]], []]);
}

export function getHistory(trackerId, from, until) {
    const instant = (value) => escapeDataString(toString(toUniversalTime(value), "o"));
    let pr_2;
    let pr_1;
    const url = `/api/telematics/trackers/${trackerId}/history?from=${instant(from)}&to=${instant(until)}`;
    pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoderWithoutErrorPage(addPrefix(url), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), TrackHistoryDto_$reflection()));
    }).then((_arg) => {
        const result_1 = _arg;
        return (result_1.tag === 1) ? (Promise.resolve((() => {
            throw new ValidationOnGetRequest(result_1.fields[0]);
        })())) : (Promise.resolve(result_1.fields[0]));
    }))));
    pr_2 = (pr_1.then((Item) => (new HistoryResult(0, [Item]))));
    return pr_2.then(void 0, ((error) => {
        if (error instanceof NotImplementedResponse) {
            return new HistoryResult(1, []);
        }
        else {
            throw error;
        }
    }));
}

function entityRoute(entityType) {
    if (entityType.tag === 1) {
        return "sets";
    }
    else {
        return "tools";
    }
}

export function assignedTrackersKey(entityType, entityId) {
    return `/api/${entityRoute(entityType)}/${entityId}/trackers`;
}

export function useAssignedTrackersIf(enabled, entityType, entityId) {
    return swr(enabled ? assignedTrackersKey(entityType, entityId) : "", (url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoderWithoutErrorPage(addPrefix(url), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), AssignedTrackersDto_$reflection()));
    }).then((_arg) => {
        const result_1 = _arg;
        return (result_1.tag === 1) ? (Promise.resolve((() => {
            throw new ValidationOnGetRequest(result_1.fields[0]);
        })())) : (Promise.resolve(result_1.fields[0]));
    })))), {
        refreshInterval: 60000,
        revalidateOnFocus: true,
    });
}

export function useAssignedTrackers(entityType, entityId) {
    return useAssignedTrackersIf(true, entityType, entityId);
}

export function assignTracker(entityType, entityId, dto) {
    const url = assignedTrackersKey(entityType, entityId);
    const body = toString_1(0, Auto_generateBoxedEncoder_437914C6(AssignTrackerDto_$reflection(), undefined, undefined, undefined)(dto));
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_1;
        return ((url_1 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_1, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [body])]), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), AssignedTrackerDto_$reflection()));
        }, refreshOn)))(true);
    }));
}

export function removeTracker(entityType, entityId, trackerId) {
    const url = concat(assignedTrackersKey(entityType, entityId), "/", ...trackerId);
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_1;
        return ((url_1 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_1, singleton(new Types_RequestProperties(0, ["DELETE"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
        }, refreshOn)))(true);
    }));
}

